interface V3IconOutProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconOut = ({ stroke = "#ABB0BA" }: V3IconOutProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.333 5V4A1.333 1.333 0 0 0 8 2.667H3.333A1.333 1.333 0 0 0 2 4v8a1.333 1.333 0 0 0 1.333 1.333H8A1.333 1.333 0 0 0 9.333 12v-1M5 8h9m0 0-2-2m2 2-2 2" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>

